module.exports = __webpack_public_path__ + "static/img/yixi_logo_512.e1c4d5f1.png";